export default __webpack_public_path__ + "30b968afc44f816ba697f60e4f938bfa.png";